// 方舟一号 API
import request from '@/utils/request'
import { getCMS2Url, getQuantAuthHeaders } from './config'

type dataType = any

export default {
  /**
   * 获取组合配置和当前状态
   * 包含：策略名称、标签、亮点、收益率、资金占比、持仓分布等
   */
  getPortfolioData(data: dataType): Promise<any> {
    return request({
      url: getCMS2Url + '/fz/detail',
      method: 'get',
      params: data.params,
      headers: {
        ...getQuantAuthHeaders(),
        ...data.headers
      }
    })
  },

  /**
   * 获取调仓历史记录（分页列表）
   * 返回数据结构：
   * - page: 当前页码
   * - page_size: 每页数量
   * - total: 总记录数
   * - list: 调仓记录数组，每条记录包含：
   *   - trade_date: 交易日期
   *   - name: 股票名称
   *   - symbol: 股票代码
   *   - bs_flag: 买卖标志 ('B' = 买入, 'S' = 卖出)
   *   - price: 交易价格
   *   - stock_ratio: 调仓后持仓比例
   *   - pre_stock_ratio: 调仓前持仓比例
   *   - expected: 调仓原因
   */
  getPerformanceData(data: dataType): Promise<any> {
    return request({
      url: getCMS2Url + '/fz/records',
      method: 'get',
      params: data.params,
      headers: {
        ...getQuantAuthHeaders(),
        ...data.headers
      }
    })
  },

  /**
   * 获取当前持仓明细
   * 包含当前持仓和当日清仓的股票
   */
  getPositions(data: dataType): Promise<any> {
    return request({
      url: getCMS2Url + '/fz/charts',
      method: 'get',
      params: data.params,
      headers: {
        ...getQuantAuthHeaders(),
        ...data.headers
      }
    })
  },

  /**
   * 获取调仓历史记录
   * 包含历史调仓操作的详细信息
   */
  getRebalancingHistory(data: dataType): Promise<any> {
    return request({
      url: getCMS2Url + '/api/v1/ark-one/rebalancing-history',
      method: 'get',
      params: data.params,
      headers: {
        ...getQuantAuthHeaders(),
        ...data.headers
      }
    })
  },

  /**
   * 获取实时价格
   * @param codes - 股票代码数组
   */
  getRealTimePrices(data: dataType): Promise<any> {
    return request({
      url: getCMS2Url + '/api/v1/ark-one/realtime-prices',
      method: 'post',
      data: data.data,
      headers: {
        ...getQuantAuthHeaders(),
        ...data.headers
      }
    })
  },
}
